import { connect } from 'react-redux';

import SurescriptsInformation from './surescripts-information';
import { fetchPrescriber, refreshPrescriber, updatePrescriber, deactivatePrescriber, reactivatePrescriber, createPrescriber } from '../actions';

const mapStateToProps = state => ({
  prescriberInfo: state.prescriberReducer.prescriberInfo,
  fetched: state.prescriberReducer.fetched,
  loading: state.prescriberReducer.loading,
  errors: state.prescriberReducer.errors
});

const mapDispatchToProps = {
  fetchPrescriber,
  refreshPrescriber,
  updatePrescriber,
  deactivatePrescriber,
  reactivatePrescriber,
  createPrescriber
};

export default connect(mapStateToProps, mapDispatchToProps)(SurescriptsInformation);
